var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLastSubmissionIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4386 0.561379C23.1871 1.30988 23.1871 2.52345 22.4386 3.27195L3.27195 22.4386C2.52345 23.1871 1.30988 23.1871 0.561379 22.4386C-0.187126 21.6901 -0.187126 20.4765 0.561379 19.728L19.728 0.561379C20.4765 -0.187126 21.6901 -0.187126 22.4386 0.561379Z",
    fill: "#BCAB79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91667 0C2.97521 0 3.83333 0.858121 3.83333 1.91667V19.1667H21.0833C22.1419 19.1667 23 20.0248 23 21.0833C23 22.1419 22.1419 23 21.0833 23H1.91667C0.858121 23 0 22.1419 0 21.0833V1.91667C0 0.858121 0.858121 0 1.91667 0Z",
    fill: "#BCAB79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastSubmissionIcon);
export default __webpack_public_path__ + "static/media/last-submission-icon.14664f1e543e6a5a139317d728baadb4.svg";
export { ForwardRef as ReactComponent };